import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import style from './Filters.module.scss'
import autoshipIcon from '../assets/icons/autoship.svg'

const DEALS = ['dealLabel']
const PRICE_RANGES = [
  'priceUnder10',
  'price10To20',
  'price20To30',
  'price30To40',
  'price40To50',
  'price50To75',
  'price75To100',
  'price100Above'
]
const CUSTOMER_RATINGS = [4, 3, 2, 1]

const FilterGroup = ({ titleKey, itemKeys }: { titleKey: string; itemKeys: string[] }) => {
  const { t } = useSurveyLocale()
  return (
    <div className={style.group}>
      <div className={style.groupTitle}>{t('questions', 'ec', 'chewy', titleKey)}</div>
      <ul className={style.options}>
        {itemKeys.map(key => (
          <li key={key} className={style.option}>
            <EmptyLink color="#1C49C4">
              <label className={style.optionLabel}>
                <span className={style.checkbox} />
                <span className={style.optionText}>{t('questions', 'ec', 'chewy', key)}</span>
              </label>
            </EmptyLink>
          </li>
        ))}
      </ul>
    </div>
  )
}

const RatingStars = ({ filled }: { filled: number }) => (
  <span className={style.ratingStars}>
    {[1, 2, 3, 4, 5].map(n => (
      <i key={n} className={`pi ${n <= filled ? 'pi-star-fill' : 'pi-star'} ${style.ratingStar}`} />
    ))}
  </span>
)

const CustomerRatingGroup = () => {
  const { t } = useSurveyLocale()
  return (
    <div className={style.group}>
      <div className={style.groupTitle}>{t('questions', 'ec', 'chewy', 'customerRating')}</div>
      <ul className={style.options}>
        {CUSTOMER_RATINGS.map(value => (
          <li key={value} className={style.option}>
            <EmptyLink color="#1C49C4">
              <label className={style.optionLabel}>
                <span className={style.checkbox} />
                <RatingStars filled={value} />
                <span className={style.ratingAndUp}>{t('questions', 'ec', 'chewy', 'andUp')}</span>
              </label>
            </EmptyLink>
          </li>
        ))}
      </ul>
    </div>
  )
}

const Filters = () => {
  const { t } = useSurveyLocale()
  return (
    <aside className={style.filters}>
      <EmptyLink color="#1C49C4">
        <label className={style.autoship}>
          <span className={style.checkbox} />
          <div className={style.autoshipBody}>
            <span className={style.autoshipTitle}>
              <img src={autoshipIcon} alt="" role="presentation" className={style.autoshipIcon} />
              {t('questions', 'ec', 'chewy', 'autoship')}
            </span>
            <span className={style.autoshipNote}>{t('questions', 'ec', 'chewy', 'autoshipSaveNote')}</span>
          </div>
        </label>
      </EmptyLink>
      <FilterGroup titleKey="dealsSavings" itemKeys={DEALS} />
      <FilterGroup titleKey="priceTitle" itemKeys={PRICE_RANGES} />
      <CustomerRatingGroup />
    </aside>
  )
}

export default Filters
